import React, { useCallback, useEffect, useState } from 'react';


import api from '../../../services/api';

import { House, MagnifyingGlass } from 'phosphor-react';

import Breadcrumbs from '../../../components/Breadcrumbs';

import { Container, HeaderSection, SearchContainer, SectionContainer1 } from './styles';

import CardCommunityCategory from './CardCommunityCategory';
import InputDebounceAdapter from '../../../components/InputDebounceAdapter';
import LoaderAtomic from '../../../components/LoaderAtomic';
import { API_S3 } from '../../../services/api_s3';

export interface IPaginationProps {
  page: number;
  maxPages: number;
  showingFrom: number;
  showingTo: number;
  totalRecords: number;
  records?: ({
    id: string;
    cluster_id: string;
    title: string;
    slug: string;
    order: string;
    thumbnail: string;
    thumbnail_url: string;
    topicsCount: number;
    description: string;
    created_at: string;
    updated_at: string;
  })[];
}

const Comunidade: React.FC = () => {

  const [forumsData, setForumsData] = useState<IPaginationProps>({} as IPaginationProps);
  const [search, setSearch] = useState('');

  // Loading
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await api.get(`/forums`, {
          params: {
            pageIndex: 0,
            pageSize: 99,
            search: search,
          }
        });

        console.log(response.data);
        setForumsData(response.data);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [search]);
  
  const handleFilterAchievement = useCallback((value: string) => {
    console.log(value);
    setSearch(value);
  }, []);

  return (
    <Container>
      {loading && (<LoaderAtomic isVisible />)}

      <HeaderSection>
        <Breadcrumbs
          icon={House}
          separator="/"
          route={[{ title: 'Comunidade', link: '/comunidade' }]}
        />
        <SearchContainer>
          <InputDebounceAdapter
            type="text"
            debounceTimeout={300}
            minLength={3}
            onChange={(event) => handleFilterAchievement(event.target.value)}
            placeholder="Busque por uma categoria..."
          />
          <MagnifyingGlass weight="duotone" />
        </SearchContainer>
      </HeaderSection>

      <SectionContainer1>
        {forumsData.records?.map((cluster) => (
          <CardCommunityCategory 
            key={cluster.id}
            description={cluster.description}
            image={`${API_S3}/clusters/${cluster.order}.webp`} 
            link={`/comunidade/` + cluster.slug}
            title={cluster.title}
            topicsCount={cluster.topicsCount}
          />
        ))}
      </SectionContainer1>
    </Container>
  );
}

export default Comunidade;